
import { useEffect, useState } from "react"
import api from "../../../services/api";
import PageTitle from "../../../components/PageTitle"
import Spinner from "../../../shared/Spinner/Spinner";
import Style from "./EnterpriseReportStyle"
import ProductRow from "./ProductRow";

interface Material {
    quantity: number,
    id: number,
    materialId: number,
    name: string,
    squareMeters: number,
}

export interface Product {
    quantity: number,
    id: number,
    productId: number,
    name: string,
    productsVariations: [],
}

export default function EnterpriseReport(props) {
    
    const [loading, setLoading] = useState(true);
    const [products, setProducts] = useState<Product[]>([])
    const [materials, setMaterials] = useState<Material[]>([])

    useEffect(() => {
        LoadItems()
    }, [])

    async function LoadItems() {
        try {
            const productsResult = await api.get(`/enterprises/${props.match.params.enterpriseId}/report/products`);
            const materialsResult = await api.get(`/enterprises/${props.match.params.enterpriseId}/report/materials`)

            setProducts(productsResult.data.products);
            setMaterials(materialsResult.data.materials);
        }
        catch (error) {
            console.error("Erro pegando produtos: ", error);
        }
        finally {
            setLoading(false)
        }
    }

    return(
        <Style className="default-page">
            <PageTitle title="Relatório de produtos e materiais" />
            <div>
                <button onClick={() => props.history.goBack()} className=" btn-secondary">Voltar</button>
            </div>
            <Spinner spinning={loading} />
            <main className="default-main">
                <div className="panel">
                    <section className="table-title">
                        <h1>Produtos</h1>
                    </section>
                    <table className="table table-bordered table-hover ">
                        <thead>
                            <tr>
                                <th></th>
                                <th>Qtd.</th>
                                <th>ID</th>
                                <th>Nome</th>
                            </tr>
                        </thead>
                        <tbody>
                            {products.length > 0 && products.map(product => {
                                return(
                                    <ProductRow 
                                        key={product.id}
                                        product={product}
                                    />
                                )
                            })}
                        </tbody>
                    </table>
                </div>
                <div className="panel">
                    <section className="table-title">
                        <h1>Materiais</h1>
                    </section>
                    <table className="table table-bordered table-hover">
                        <thead >
                            <tr>
                                <th>Qtd.</th>
                                <th>ID</th>
                                <th>Nome</th>
                                <th>m²</th>
                            </tr>
                        </thead>
                        <tbody>
                            {materials.length > 0 && materials.map(material => {
                                return(
                                    <tr key={material.id}>
                                        <td>{material.quantity}</td>
                                        <td>{material.materialId}</td>
                                        <td>{material.name}</td>
                                        <td>{material.squareMeters.toFixed(1)} m²</td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </div>
            </main>
        </Style>
    )
}
